// extracted by mini-css-extract-plugin
export default {"todoList":"TodoList_todoList__gWOKy"};